import { connect } from 'react-redux';
import { actions } from '../../../app-dux/company-dux';
import CompanySelect from './company-select.jsx';

export default connect(
    // mapStateToProps
    state => {
        return {
            companies: state.company.companies,
            companiesLoading: state.company.companiesLoading,
            companiesLoaded: state.company.companiesLoaded
        };
    },
    // mapDispatchToProps
    {
        ...actions
    }
)( CompanySelect );